import React, { Fragment } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  LinearProgress,
  List,
  Typography,
  colors,
  makeStyles,
} from "@material-ui/core";
import { ExpandMore as ExpandMoreIcon } from "@material-ui/icons";

import { OverallProgressSkeleton, SkillRow } from "./components";
import { SkillsAccordionProps } from "./types";
import { useTealium } from "@hubcapp/context";

const useStyles = makeStyles(() => ({
  accordion: {
    width: "100%",
  },
  heading: {
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "1.5rem",
    color: colors.common.black,
  },
  categoryProgressBar: {
    width: "100%",
    maxWidth: "5rem",
  },
  skillsList: {
    width: "100%",
  },
}));

const SkillsAccordion: React.FC<SkillsAccordionProps> = ({
  skillIds,
  loading = false,
  title = "",
  percentage = 0,
}) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const { trackEvent } = useTealium();

  if (loading) {
    return <OverallProgressSkeleton />;
  }

  return (
    <Fragment>
      <Accordion
        className={classes.accordion}
        onChange={() => {
          trackEvent({
            eventCategory: "View Learner - Progress",
            eventAction: "Interaction",
            eventLabel: `${title} - ${isOpen ? "Closed" : "Open"}`,
          });
          setIsOpen(!isOpen);
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between"
          >
            <Typography variant="body1" className={classes.heading}>
              {title}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={percentage || 0}
              className={classes.categoryProgressBar}
            />
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <List className={classes.skillsList}>
            {(skillIds || []).map((skillId: string) => (
              <SkillRow key={skillId} skillId={skillId} />
            ))}
          </List>
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

export default SkillsAccordion;
